import React from "react";
import Toaster from "../Toaster";
import CclDataTable, { CclDataTableColumnDef, CclDataTableColumnType } from "../CclDataTable";
import ApiAdminUsers from "../../code/api/ApiAdminUsers";
import { AdminUserModel } from "../../code/models/AdminUserModel";
import ApiCompany from "../../code/api/ApiCompany";
import Company from "../../code/models/Company";
import AdminRole from "../../code/models/AdminRole";
import ApiAdminRole from "../../code/api/ApiAdminRole";
import "../../css/adminusermanagement.css";
import ButtonConfirm, { ButtonConfirmSize } from "../ButtonConfirm";
import AuthAdminUserModel from "../../code/models/AuthAdminUserModel";


interface IAdminUserForm {
    adminUser: AuthAdminUserModel;
}

export default function AdminUserForm({ adminUser }: IAdminUserForm) {
    const [toastMessage, setToastMessage] = React.useState<string>("");
    const [selectedAdminUser, setSelectedAdminUser] = React.useState<AdminUserModel | null>(null);
    const [editAdminUser, setEditAdminUser] = React.useState<AdminUserModel | null>(null);
    const [anyChanges, setAnyChanges] = React.useState<boolean>(false);

    React.useEffect(() => {
        loadData();
    }, []);

    async function loadData() {
        ApiAdminUsers.getAdminUser(adminUser.id).then((user) => {
            setUser(user);
        });
    }

    function setUser(user: AdminUserModel) {
        setSelectedAdminUser(user);
        setEditAdminUser(structuredClone(user));
    }

    function checkHasChanges() {
        if (editAdminUser == null || selectedAdminUser == null) {
            setAnyChanges(false);
            return;
        }

        var isAnyChanges =
            selectedAdminUser.firstName !== editAdminUser.firstName ||
            selectedAdminUser.lastName !== editAdminUser.lastName ||
            selectedAdminUser.logonId !== editAdminUser.logonId ||
            selectedAdminUser.password !== editAdminUser.password;

        setAnyChanges(isAnyChanges);
    }


    function saveAdminUserClick(): void {
        if (anyChanges && !!editAdminUser && !!selectedAdminUser) {
            ApiAdminUsers.updateAdminUser(editAdminUser).then((savedUser) => {
                setToastMessage("The user information has been updated.");
                setUser(savedUser);
            });
        }
    }

    return (
        <React.Fragment>
            <div className="container h-100 d-flex justify-content-center">
                <div className="col-md-4 mt-4">
                    <div className="row mt-4">
                        <label htmlFor="loginIdInput" className="form-label">User Id</label>
                        <input className="form-control" disabled={!editAdminUser}
                            id="loginIdInput" defaultValue={selectedAdminUser?.logonId || ""} autoComplete={"off"}
                            onChange={(e) => {
                                if (!!editAdminUser) {
                                    editAdminUser.logonId = e.target.value;
                                    checkHasChanges();
                                }
                            }}></input>
                    </div>
                    <div className="row mt-4">
                        <label htmlFor="firstNameInput" className="form-label">First Name</label>
                        <input className="form-control" disabled={!editAdminUser}
                            id="firstNameInput" defaultValue={selectedAdminUser?.firstName || ""} autoComplete={"off"}
                            onChange={(e) => {
                                if (!!editAdminUser) {
                                    editAdminUser.firstName = e.target.value;
                                    checkHasChanges();
                                }
                            }}></input>
                    </div>
                    <div className="row mt-4">
                        <label htmlFor="lastNameInput" className="form-label">Last Name</label>
                        <input className="form-control" disabled={!editAdminUser}
                            id="lastNameInput" defaultValue={selectedAdminUser?.lastName || ""} autoComplete={"off"}
                            onChange={(e) => {
                                if (!!editAdminUser) {
                                    editAdminUser.lastName = e.target.value;
                                    checkHasChanges();
                                }
                            }}></input>
                    </div>
                    <div className="row mt-4">
                        <label htmlFor="pwdInput" className="form-label">Password</label>
                        <input className="form-control" disabled={!editAdminUser}
                            id="pwdInput" defaultValue={selectedAdminUser?.password || ""} autoComplete={"off"}
                            onChange={(e) => {
                                if (!!editAdminUser) {
                                    editAdminUser.password = e.target.value;
                                    checkHasChanges();
                                }
                            }}></input>
                    </div>
                    <div className="row mt-4">
                        <button className={"btn btn-sm btn-primary adminusermgt-savebtn"}
                            disabled={!editAdminUser || !anyChanges} onClick={saveAdminUserClick}>Update</button>
                    </div>
                </div>
            </div>
            <Toaster title="Admin Users" subtitle="User" message={toastMessage} key={"adminuserfrmtoast"} />
        </React.Fragment>
    )
}
